import * as C from "../isms/constants";
import { SIGN_OUT } from "../actions";

// ISMS(2026-09-15) — 서버 session.check 응답·차단/잠금·OTP 진행 상태. OTP 챌린지 객체(CognitoUser)는
// 직렬화 불가라 ismsClient 모듈 메모리에 두고 여기엔 표시용 값만 둔다.
const initial = {
  status: null, // session.check 응답 원본 {enabled, idle{}, ip{}, audit{}, otp{}, ...}
  locked: false,
  lockReason: null,
  blocked: false,
  blockMessage: null,
  contact: null,
  idleWarning: null, // {remainingSec} | null
  otp: null, // {mode:'signin'|'unlock', email, reason, attemptsLeft, retryAfterSec, expiresInSec, error, busy} | null
};

export default function isms(state = initial, action) {
  switch (action.type) {
    case C.ISMS_STATUS_RECEIVED: {
      const s = action.status || {};
      return {
        ...state,
        status: s,
        locked: !!s.locked,
        lockReason: s.locked ? s.reason : null,
        blocked: !!s.blocked,
        contact: (s.ip && s.ip.contact) || state.contact,
        idleWarning: s.locked ? null : state.idleWarning,
      };
    }
    case C.ISMS_LOCKED:
      return { ...state, locked: true, lockReason: action.reason || "IDLE", idleWarning: null };
    case C.ISMS_UNLOCKED:
      return { ...state, locked: false, lockReason: null, idleWarning: null };
    case C.ISMS_BLOCKED:
      return { ...state, blocked: true, blockMessage: action.message || null, contact: action.contact || state.contact };
    case C.ISMS_IDLE_WARNING:
      return { ...state, idleWarning: action.warning };
    case C.ISMS_OTP_REQUIRED:
      return { ...state, otp: { ...action.otp, error: null, busy: false } };
    case C.ISMS_OTP_UPDATED:
      return state.otp ? { ...state, otp: { ...state.otp, ...action.patch } } : state;
    case C.ISMS_OTP_DONE:
      return { ...state, otp: null };
    case C.ISMS_RESET:
    case SIGN_OUT:
      return { ...initial };
    default:
      return state;
  }
}

export const getIsms = (state) => state.isms;
